import type { LucideIcon } from 'lucide-react';
import { Inbox } from 'lucide-react';

export function EmptyState({
  title,
  text,
  icon: Icon = Inbox,
  action,
}: {
  title: string;
  text?: string;
  icon?: LucideIcon;
  action?: { label: string; onClick: () => void };
}) {
  return (
    <div className="empty" role="status">
      <Icon size={28} strokeWidth={1.5} />
      <div className="empty-title">{title}</div>
      {text && <div style={{ maxWidth: 420 }}>{text}</div>}
      {action && (
        <button type="button" className="btn" style={{ marginTop: 8 }} onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
